module.exports = __webpack_public_path__ + "img/festival-circulos.9a2d872f.png";